import api from '@/modules/api.service';

export async function deletarRelatorioUseCase(id: number): Promise<void> {
  try {
    await api.delete(`/relatorios/atividades/${id}`);
  } catch (error) {
    console.error('Erro ao deletar relatório:', error);
    throw error;
  }
}
